// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {combineReducers} from 'redux';
import {UserTypes} from 'mattermost-redux/action_types';

import {ActionTypes} from 'utils/constants.jsx';

const defaultState = {
    show: false,
};

function editingPost(state = defaultState, action) {
    switch (action.type) {
    case ActionTypes.SHOW_EDIT_POST_MODAL:
        return {
            ...action.data,
            show: true,
        };
    case ActionTypes.HIDE_EDIT_POST_MODAL:
        return {
            show: false,
        };

    case UserTypes.LOGOUT_SUCCESS:
        return defaultState;
    default:
        return state;
    }
}
function setAddPostToTask (state = defaultState, action) {
    switch (action.type) {
    case ActionTypes.SHOW_ADD_POST_TO_TASK_MODAL:
        return {
            ...action.data,
            show: true,
        };
    case ActionTypes.HIDE_ADD_POST_TO_TASK_MODAL:
        return {
            show: false,
        };

    case UserTypes.LOGOUT_SUCCESS:
        return defaultState;
    default:
        return state;
    }
}

function setAddPostToNote (state = defaultState, action) {
    switch (action.type) {
    case ActionTypes.SHOW_ADD_POST_TO_NOTE_MODAL:
        return {
            ...action.data,
            show: true,
        };
    case ActionTypes.HIDE_ADD_POST_TO_NOTE_MODAL:
        return {
            show: false,
        };

    case UserTypes.LOGOUT_SUCCESS:
        return defaultState;
    default:
        return state;
    }
}

export default combineReducers({
    editingPost,setAddPostToTask,setAddPostToNote
});
